import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/qx-solarheart/qx-solarheart/app/layouts/default.vue").then(m => m.default || m)),
  test: defineAsyncComponent(() => import("/home/runner/work/qx-solarheart/qx-solarheart/app/layouts/test.vue").then(m => m.default || m))
}